import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IApplicationIdField {
	changeApplicationId: (value: string) => void;
}

const ApplicationIdField: React.FC<IApplicationIdField> = ({ changeApplicationId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterApplicationId') }], [t]);

	return (
		<FormInput
			testId="ApplicationIdField"
			name="applicationId"
			label="applicationIdLabel"
			maxLength={100}
			onChange={changeApplicationId}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ApplicationIdField);
